import { render, staticRenderFns } from "./employerList.vue?vue&type=template&id=c0652b4a&scoped=true"
import script from "./employerList.vue?vue&type=script&lang=js"
export * from "./employerList.vue?vue&type=script&lang=js"
import style0 from "./employerList.vue?vue&type=style&index=0&id=c0652b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0652b4a",
  null
  
)

export default component.exports